import { useState } from 'react';

import { CssBaseline } from '@mui/material';
import Box from '@mui/material/Box';

import { NavigationDrawerWithOnlyLogout } from '@/features/layouts/components/NavigationDrawer/NavigationDrawerWithOnlyLogout';

import { stylesMainContent, stylesMainContentBody, stylesMainLayout } from './MainLayout.styles';

type MainLayoutProps = {
  children: React.ReactNode;
};

export const MainLayoutWithOnlyLogout: React.FunctionComponent<MainLayoutProps> = ({ children }) => {
  const [isSideBarDrawerOpen, setIsSideBarDrawerOpen] = useState(false);

  const handleHoverSideBarDrawer = () => {
    setIsSideBarDrawerOpen((isOpen) => !isOpen);
  };

  return (
    <Box sx={stylesMainLayout}>
      <CssBaseline />
      <NavigationDrawerWithOnlyLogout
        onHoverSideBarDrawer={handleHoverSideBarDrawer}
        isSideBarDrawerOpen={isSideBarDrawerOpen}
      />
      <Box data-testid='main-box' component='main' sx={stylesMainContent}>
        <Box sx={stylesMainContentBody}>{children}</Box>
      </Box>
    </Box>
  );
};
